import React from "react";
import { Header, Container, Responsive } from "semantic-ui-react";
import PropertyComp from "../../components/PropertyComp";
import { mainIp } from "../../API/API";

export const typeOfPropertySelector = [
  {
    key: "home",
    value: "home",
    text: "Casa"
  },
  {
    key: "department",
    value: "department",
    text: "Departamento"
  }
];

class PropiedadesPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="marginTop">
        <Container>
          <Header
            as="h2"
            className="title"
            style={{
              color: "#5594b7",
              fontSize: "40px",
              textAlign: "center",
              marginBottom: "40px"
            }}
          >
            Propiedades
          </Header>
          <div>
            {this.props.data.map((property, index) => {
              let typeOfProperty = "";
              const foundTypeProperty = typeOfPropertySelector.find(
                typeProperty => {
                  return typeProperty.value === property.typeOfProperty;
                }
              );
              if (foundTypeProperty !== undefined) {
                typeOfProperty = foundTypeProperty.text;
              }
              let textposition = false;
              if (index % 2 === 0) {
                textposition = true;
              }
              return (
                <PropertyComp
                  url={this.props.url}
                  title={property.name}
                  description={property.smallDesc}
                  image={mainIp + property.thumbnail.result}
                  rightImage={textposition}
                  propertyType={typeOfProperty}
                  address={property.address}
                  style={{ paddingBottom: "5rem" }}
                  idprop={property.url}
                />
              );
            })}
          </div>
        </Container>
      </div>
    );
  }
}

export default PropiedadesPage;
